import { ExtensionType, ExtensionTypes } from '../types'

interface ExtensionAccess {
  hasLuoxDirectMarketingAccess: boolean
  hasLuoxDynamicTariffAccess: boolean
  hasOstromAccess: boolean
  hasInexogyAccess: boolean
  hasTibberAccess: boolean
  hasAi360PowerFixAccess: boolean
  hasAi360PowerShareAccess: boolean
}

/**
 * Returns for each extension whether it is displayed. E.ON is exclusive to e3dc (hidden in Flow).
 */
export const getExtensionVisibility = (access: ExtensionAccess, isFlowTheme: boolean): Record<ExtensionType, boolean> => ({
  [ExtensionTypes.LuoxOne]: access.hasLuoxDirectMarketingAccess,
  [ExtensionTypes.LuoxTwo]: access.hasLuoxDynamicTariffAccess,
  [ExtensionTypes.OStrom]: access.hasOstromAccess,
  [ExtensionTypes.Tibber]: access.hasTibberAccess,
  [ExtensionTypes.Inexogy]: access.hasInexogyAccess,
  [ExtensionTypes.Eon]: !isFlowTheme,
  [ExtensionTypes.Ai360PowerShare]: access.hasAi360PowerShareAccess,
  [ExtensionTypes.Ai360PowerFix]: access.hasAi360PowerFixAccess,
})
